<template>

  <div>

    <font-awesome-icon icon="desktop" class="svg desktop" :style="{ color: '#212426' }" v-if="settings.device==='desktop'" />

    <font-awesome-icon icon="mobile-alt" class="svg mobile" :style="{ color: '#212426' }" v-if="settings.device==='mobile'" />

  </div>

</template>

<script>
export default {
  name: 'Device',
  props: ['settings'],
  data() {
	return {
	  
	}
  }
}
</script>
<style lang="less" scoped>
.svg {
  display: inline-block;
  height: 20px;
  width: 24px;
  &.mobile {
    height: 22px;
    width: 15px;
  }
}
@media screen and (min-width: 960px) {
  .svg {
    margin-left: 9px;
    margin-top: 13px;
    &.mobile {
      margin-top: 10px;
      margin-left: 12px;
      height: 26px;
      width: 18px;
    }
  }
}
</style>